import { render } from "./DataTable.vue?vue&type=template&id=e59450bc"
import script from "./DataTable.vue?vue&type=script&lang=ts"
export * from "./DataTable.vue?vue&type=script&lang=ts"
script.render = render

export default script